"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateAction = decorateAction;
exports.decorate = decorate;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _action = _interopRequireDefault(require("./action"));

var _actions = _interopRequireDefault(require("./actions"));

var _withActions = require("./withActions");

function applyDecorators(decorators, actionCallback) {
  return function () {
    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    var decorated = decorators.reduce(function (args, fn) {
      return fn(args);
    }, _args);
    actionCallback.apply(void 0, (0, _toConsumableArray2.default)(decorated));
  };
}

function decorateAction(decorators) {
  return function (name, options) {
    var callAction = (0, _action.default)(name, options);
    return applyDecorators(decorators, callAction);
  };
}

function decorate(decorators) {
  var decorated = decorateAction(decorators);

  var decoratedActions = function decoratedActions() {
    var rawActions = _actions.default.apply(void 0, arguments);

    var actionsObject = {};
    Object.keys(rawActions).forEach(function (name) {
      actionsObject[name] = applyDecorators(decorators, rawActions[name]);
    });
    return actionsObject;
  };

  return {
    action: decorated,
    actions: decoratedActions,
    withActions: (0, _withActions.createDecorator)(decoratedActions)
  };
}